import type { ButtonHTMLAttributes } from 'react'
import { cx } from './cx'

type Variant = 'primary' | 'secondary'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
}

const base =
  'inline-flex items-center justify-center gap-sm min-h-[44px] px-md rounded-md ' +
  'text-body font-medium select-none transition-colors duration-150 ' +
  'disabled:opacity-50 disabled:cursor-not-allowed'

const variants: Record<Variant, string> = {
  // accent fill + on-accent text (DESIGN.md button-primary)
  primary: 'bg-accent text-accent-foreground hover:bg-accent/90 active:bg-accent/80',
  // transparent + border + foreground text (DESIGN.md button-secondary)
  secondary:
    'bg-transparent text-foreground border border-border hover:bg-foreground/5 active:bg-foreground/10',
}

export function Button({
  variant = 'primary',
  className,
  type = 'button',
  ...rest
}: ButtonProps) {
  return (
    <button type={type} className={cx(base, variants[variant], className)} {...rest} />
  )
}
